import React from "react";
import Ring from "./Ring";
import { AppTheme } from "./App";

interface WheelProps {
  theme: AppTheme;
  onClick: () => void;
  innerNames: string[];
  outerNames: string[];
  thirdNames?: string[]; // Optional third ring of names
  innerRotation: number;
  outerRotation: number;
  thirdRotation?: number; // Optional third ring rotation
  trioMode?: boolean; // Flag to indicate if we're in trio mode
}

const Wheel: React.FC<WheelProps> = ({
  theme,
  onClick,
  innerNames,
  outerNames,
  thirdNames = [],
  innerRotation,
  outerRotation,
  thirdRotation = 0,
  trioMode = false,
}) => {
  const [buttonRotation, setButtonRotation] = React.useState<number>(1);

  React.useEffect(() => {
    setButtonRotation(buttonRotation === 0 ? 360 : 0);
  }, [innerRotation]);

  // Calculate radii based on whether we're in trio mode or not
  const innerRadius = trioMode ? 152 : 182;
  const middleRadiusInner = trioMode ? 232 : 266;
  const middleRadiusOuter = trioMode ? 296 : 336;
  const outerRadiusInner = 296;
  const outerRadiusOuter = 350;

  return (
    <svg
      className="WheelSvg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 700 700"
      width="auto"
      height="100%"
      onClick={onClick}
    >
      <g className="animated-rotation" transform={`rotate(${innerRotation})`}>
        <Ring
          theme={theme}
          strings={innerNames}
          cx={350}
          cy={350}
          innerRadius={innerRadius}
          outerRadius={middleRadiusInner}
        />
      </g>
      <g className="animated-rotation" transform={`rotate(${outerRotation})`}>
        <Ring
          theme={theme}
          strings={outerNames}
          cx={350}
          cy={350}
          innerRadius={middleRadiusInner}
          outerRadius={trioMode ? middleRadiusOuter : middleRadiusOuter}
        />
      </g>
      {trioMode && thirdNames.length > 0 && (
        <g className="animated-rotation" transform={`rotate(${thirdRotation})`}>
          <Ring
            theme={theme}
            strings={thirdNames}
            cx={350}
            cy={350}
            innerRadius={middleRadiusOuter}
            outerRadius={outerRadiusOuter}
          />
        </g>
      )}
      <g className="animated-rotation" transform={`rotate(${buttonRotation})`}>
        <g>
          <circle
            cx={350}
            cy={350}
            r={trioMode ? 100 : 119}
            fill={
              theme === 'bw' 
                ? '#180f26' /* Dark purple for BW theme */
                : theme === 'tomtbola' 
                  ? '#f27656' /* Red for Tomtbola */
                  : '#180f26' /* Dark purple for Fikahjulet */
            }
            filter="drop-shadow(0px 4px 8px rgba(0,0,0,0.3))"
          />
          {theme === 'tomtbola' ? (
            <text
              x="50%"
              y="50%"
              dominantBaseline="middle"
              textAnchor="middle"
              fill="white"
              fontSize="32" 
              fontWeight="700"
              fontFamily="'Geist Sans', sans-serif"
            >
              Starta
            </text>
          ) : (
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 2429.18 2429.18" 
              width={trioMode ? "100" : "120"} 
              height={trioMode ? "100" : "120"}
              fill="#ffffff" /* White fill */
              x={trioMode ? "300" : "290"} 
              y={trioMode ? "300" : "290"} 
            >
              <path d="M1274.26 1408.53h-.51V183.86c400.12 16.18 741.14 261.78 895.08 608.8h91.24c-159.21-394.49-538.54-676.54-985.81-693.9q-21.81-.86-43.81-.85c-613 0-1109.89 496.91-1109.89 1109.89s496.91 1109.89 1109.88 1109.89c544.43 0 997.29-392 1091.77-909.16ZM206.81 1207.8c0-433.85 269.6-804.72 650.39-954.25-158 128.5-259.06 325.16-259.06 544.81 0 313.89 206.41 577.31 490.37 664.25L478 1902.25c-168.34-182.59-271.19-426.51-271.19-694.45m982.66 1023.93c-250.71-10.14-478.2-110.35-651-269.14l651-468.83Zm0-823.2c-289.14-48.66-509.29-305.74-509.29-610.17 0-303.25 218.76-563.56 506.24-614.37l3.36-.14Zm84.28 823.21v-738.93h942.48c-119.74 414.39-493.97 720.79-942.48 738.93" />
            </svg>
          )}
        </g>
      </g>
    </svg>
  );
};

export default Wheel;
